import React from 'react';
import { Link, IndexLink } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import * as ImageUrl from "../../../constants/constant.js";
import * as constant from "../../../constants/constant.js";
import * as appointmentActions from '../../../actions/appointmentActions.js';
import * as disputeActions from '../../../actions/disputeActions.js';
import * as dashboardActions from "../../../actions/dashboardActions.js";
import ReactLoading from 'react-loading';
import { bindActionCreators } from 'redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Reaptcha from 'reaptcha';
import moment from 'moment';
import '../../../styles/css/disputeHelp.css'
import { Button, Form, FormGroup, Label, Input, Alert } from 'react-bootstrap';
import DisputeHeader from './disputeHeader.js';
import DisputeFooter from './disputeFooter.js';
// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class DisputeList extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            logoutButton: false,
            disputeList: [],
            isLoader: false,
            searchTerm: '',
            searchedDisputedList: [],

        };
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this._logout = this._logout.bind(this);
    }
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node && this.node.contains(e.target)) {
            return;
        }

        this.handleClick();
    }
    handleClick = () => {
        if (!this.state.logoutButton) {
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            logoutButton: !prevState.logoutButton,
        }));
    }
    _logout(event) {
        console.log("--------->>", this.props)
        let userId = localStorage.getItem("userId");
        this.props.actions.logout({ 'userId': userId });

        event.preventDefault();
        localStorage.clear();
        this.props.history.push("/");
    }

    componentWillMount() {
        console.log("----999-->", this.props);
        let { history, disputeactions } = this.props;
        let searchTerm = history.location.state ? history.location.state.searchTerm : '';
        if (searchTerm) {
            disputeactions.searchDispute({ searchTerm });
        }
    }
    componentWillReceiveProps(nextProps) {
        console.log("------>>", nextProps);
        let searchedDisputedList = (nextProps.dispute && nextProps.dispute.searchedDisputedList)
            ? nextProps.dispute.searchedDisputedList : [];
        if (searchedDisputedList) {
            this.setState({ searchedDisputedList })
        }
    }

    onChange = (event) => {
        let inputName = event.target.name;
        let inputValue = event.target.value;
        this.setState({
            [inputName]: inputValue
        }, () => {
            console.log("--->>", this.state)
        });
    };

    searchDispute = (e) => {
        e.preventDefault()
        let searchTerm = this.state.searchTerm
        if (searchTerm) {
            // console.log("ddddd", searchTerm)
            // return;
            // this.props.history.match
            // this.props.history.push({
            //     pathname: '/disputes/searchDisputelist',
            //     // search: `?query=${searchTerm}`,
            //     state: { searchTerm }
            // })
            this.props.disputeactions.searchDispute({ searchTerm });
        }
    }

    render() {
        var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        if (user && user.gender == undefined) {
            user = { ...user, gender: 'Male' }
            // localStorage.setItem('user', JSON.stringify(user));
            // user = JSON.parse(localStorage.getItem("user"));
        }
        // var gender = localStorage.getItem('user')
        var defaultImagePath = (user && user.gender) == 'Male' ?
            constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        var imagePath = ''
        if (user && user.image == "noUserImage.jpg") {
            imagePath = user && user.gender == 'Male' ?
                constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        } else {
            imagePath =
                ImageUrl.PRODUCTION_IMAGE_URL +
                "uploads/" +
                localStorage.getItem("userId") +
                "/" +
                (user && user.image);
        }
        let rows = []
        let searchedDisputedList = this.state.searchedDisputedList
        if (searchedDisputedList && searchedDisputedList.length > 0) {
            searchedDisputedList.forEach(dispute => {
                let section =
                    <div className="col-md-8 offset-md-2">
                        <div className="textBlock">
                            <h4>{dispute.title}</h4>
                            <p>{dispute.description}
                        </p>
                        </div>
                    </div>

                rows.push(section)
            });
        } else {
            rows.push(<div className="col-md-6">
                OOps No Dispute Found
            </div>)

        }

        return (
            <div className="wrapper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <DisputeHeader inputRef={el => this.inputElement = el} _logout={this._logout} handleClick={this.handleClick} logoutButton={this.state.logoutButton} />
                        </div>
                    </div>
                </div>
                <div className="search-bar">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div class="topnav">
                                    <h3>We're here to help</h3>
                                    <div class="search-container">
                                        <form >
                                            <input
                                                type="text"
                                                placeholder="Search.."
                                                className="search"
                                                value={this.state.searchTerm}
                                                onChange={this.onChange}
                                                name="searchTerm"
                                            ></input>
                                            <button
                                                className="btn btn-warning btn-lg"
                                                onClick={this.searchDispute}
                                                type="text"
                                            >Search</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="HelpList">
                    <div className="container">
                        <div className="row">

                           {rows}
                        </div>
                    </div>
                </div>
                <DisputeFooter />
            </div>);
    }
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    return {
        dispute: state.dispute

        // specialistPatients: state.specialist.specialistPatients
    };
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        appointmentactions: bindActionCreators(appointmentActions, dispatch),
        disputeactions: bindActionCreators(disputeActions, dispatch),
        actions: bindActionCreators(dashboardActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DisputeList);